import { SelectionEntry } from "@app/components/core/SelectionEntry/SelectionEntry"
import Skeleton from "react-loading-skeleton"
import "./PersonTypeSelector.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { Tooltip } from "@tecreation/funnel-components"
import { useGetStrings } from "@app/store/service/cmsService"
import { useMemo } from "react"

/**
 *
 * @param {{count,onAdd,onRemove,text,subText,isSkeleton: boolean,rateText,notification}} param0
 * @returns
 */
const PersonTypeSelector = ({ count, onAdd, onRemove, text, subText, isSkeleton, plusDisabled, rateText, notification }) => {
	const {
		data: { moreInformation },
	} = useGetStrings(undefined)

	const cleanNotification = useMemo(() => {
		const html = notification
		const div = document.createElement("div")
		div.innerHTML = html
		const newNotification = div.textContent
		return newNotification
	}, [notification])

	return (
		<SelectionEntry count={count} onAdd={onAdd} onRemove={onRemove} isSkeleton={isSkeleton} plusDisabled={plusDisabled} ariaLabel={text}>
			<h2 className="visitorKind f3 f-lg-2 color-fg-primary">
				{isSkeleton ? <Skeleton /> : text}
				{notification && (
					<div className="visitorKindNotification pl-2 f4">
						<Tooltip text={cleanNotification} showArrow position="top">
							<span className="ml-2" tabIndex={0} role="button" aria-label={moreInformation}>
								<FontAwesomeIcon icon={faInfoCircle} />
							</span>
						</Tooltip>
					</div>
				)}
			</h2>
			<div className="f4 color-fg-secondary">{isSkeleton ? <Skeleton /> : subText}</div>
			{rateText && <span className="p-1 color-bg-neutral-500">{rateText}</span>}
		</SelectionEntry>
	)
}

export { PersonTypeSelector }
